export enum RmCalendarEntryType {
    WorkTime = 0,
    Vacation = 1,
    Sick = 2,
    TimeOff = 3,
    Appointment = 4,
    Training = 5,
    BusinessTrip = 6,
    ProjectStart = 7,
    ProjectEnd = 8,
    PublicHoliday = 9,
    SpecialLeave = 10,
    TeamsStatus = 11,
}

export enum RmDecisionMode {
    None = 0,
    Approval = 1,
    Invitation = 2
}

export enum RmDecisionStatus {
    None = 0,
    Pending = 1,
    Accepted = 2,
    Rejected = 3,
    Cancelled = 4
}

export enum RmDayPart {
    None = 0,
    FullDay = 1,
    Morning = 2,
    Afternoon = 3
}